@if (showError()) {
  <ngb-alert insert-alert-icon [dismissible]="true" type="danger" (closed)="closeNotification()" autoFocus tabindex="0">
    <div id="errorMessage" i18n="@@upp.history.no.rule.found">No rule ID found with search criteria</div>
  </ngb-alert>
}
@if (isLoading()) {
  <ama-loading-alert [sendingStatus]="isLoading()"></ama-loading-alert>
}

<h1 i18n="@@upp.history.rule.title">Rule history</h1>
<div>
  <form [formGroup]="ruleForm" class="styled-form" (ngSubmit)="submitForm()">
    <div class="row">
      <div class="col text-end mb-2">
        <button
          (click)="clearForm()"
          class="btn btn-outline-primary btn-sm"
          i18n="@@upp.global.button.clear"
          type="button"
          data-test="clear-btn"
        >
          Clear
        </button>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-3 padding-4">
        <label class="form-label" for="fromDate" i18n="@@upp.history.rule.label.from">From</label>
        <span class="mandatory ms-1">*</span>
        <div
          class="input-group"
          [class.is-invalid]="ruleForm.get('fromDate')?.invalid && ruleForm.get('fromDate')?.touched"
        >
          <input
            #fromDateInput
            type="text"
            class="form-control df-input-withicon"
            id="fromDate"
            formControlName="fromDate"
            ngbDatepicker
            #fromDatePicker="ngbDatepicker"
            (dateSelect)="fromDateInput.focus()"
          />
          <div class="input-group-append">
            <button class="input-group-text fa-light fa-calendar" (click)="fromDatePicker.toggle()" type="button">
              <span class="visually-hidden">Toggle from date</span>
            </button>
          </div>
        </div>
        @if (ruleForm.get('fromDate')?.errors?.['required'] && ruleForm.get('fromDate')?.touched) {
          <div class="invalid mt-1" i18n="@@upp.history.rule.error.startDate" data-test="rule-validation-message"
            >Please enter a valid start date format</div
          >
        }
      </div>
      <div class="col-md-3 padding-4">
        <label class="form-label" for="toDate" i18n="@@upp.history.rule.label.to">To</label>
        <span class="mandatory ms-1">*</span>
        <div
          class="input-group"
          [class.is-invalid]="ruleForm.get('toDate')?.invalid && ruleForm.get('toDate')?.touched"
        >
          <input
            #toDateInput
            type="text"
            class="form-control df-input-withicon"
            id="toDate"
            formControlName="toDate"
            ngbDatepicker
            #toDatePicker="ngbDatepicker"
            (dateSelect)="toDateInput.focus()"
          />
          <div class="input-group-append">
            <button class="input-group-text fa-light fa-calendar" (click)="toDatePicker.toggle()" type="button">
              <span class="visually-hidden">Toggle to date</span>
            </button>
          </div>
        </div>
        @if (ruleForm.errors?.['dateRange']) {
          <div class="invalid mt-1" data-test="rule-validation-message" i18n="@@upp.history.rule.error.dateRange"
            >Please enter a valid date range</div
          >
        }
        @if (ruleForm.get('toDate')?.errors?.['required'] && ruleForm.get('toDate')?.touched) {
          <div class="invalid mt-1" data-test="rule-validation-message" i18n="@@upp.history.rule.error.endDate"
            >Please enter a valid end date format</div
          >
        }
      </div>
      <div class="col-md-6 padding-4">
        <label class="form-label" for="user" i18n="@@upp.history.rule.label.user">User</label>
        <div class="input-group mb-5">
          <input type="search" id="user" formControlName="user" class="form-control" aria-label="User" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 padding-4">
        <label class="form-label" for="ruleId" i18n="@@upp.history.rule.label.id">Rule ID</label>
        <div class="input-group mb-5">
          <input type="search" id="ruleId" formControlName="ruleId" class="form-control" aria-label="Rule ID" />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-5">
      <button class="btn btn-primary" type="submit" data-test="search-btn">Search</button>
    </div>
  </form>
</div>

<div class="row mt-7">
  <div id="search-result" class="col">
    <div class="ag-theme-alpine grid-container">
      <ag-grid-angular
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions"
        class="grid-component"
      ></ag-grid-angular>
    </div>
  </div>
</div>
